import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import { AdminHinodesList } from './widgets/AdminHinodesList'

const AdminHinodesOverview = (props) => {
  const dashboardBreadCrumbs: Array<PageLink> = [
    {
      title: 'Admin',
      path: '/admin',
      isSeparator: false,
      isActive: false,  
    },
  ]

  return (
    <>
      <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        Hotel Importer Nodes verwalten
      </PageTitle>
      <div className="row">
        <div className="col-xl-12">
            <AdminHinodesList />
        </div>
      </div>
    </>
  )
}

export { AdminHinodesOverview }
